import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Td, Tr } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';
import * as R from 'ramda';
import { Fragment, useMemo } from 'react';
import { TableColor } from 'src/types/crudTable';
import { getColumnStyleAndProps } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var TableRow = function TableRow(_ref) {
  var row = _ref.row,
      rowToSave = _ref.rowToSave,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview;

  var _ref2 = row.original || {},
      _destroy = _ref2._destroy;

  var isSelected = row.getIsSelected();
  var isRowChanged = useMemo(function () {
    return Boolean(rowToSave);
  }, [rowToSave]);

  if (row._destroy || _destroy) {
    return null;
  }

  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(Tr, {
      backgroundColor: isSelected ? TableColor.bg_row_selected : '',
      _hover: {
        backgroundColor: TableColor.bg_hovered,
        '> td': {
          backgroundColor: TableColor.bg_hovered
        }
      },
      borderBottomColor: TableColor.border,
      borderBottomWidth: "1px",
      e2eid: "CrudTable_TableRow_Tr",
      children: row.getVisibleCells().map(function (cell) {
        var _columnDef$cell;

        var columnDef = cell.column.columnDef;
        var styleAndProps = getColumnStyleAndProps(cell.column, false, isDisabled, isRowChanged && R.has(cell.column.id, rowToSave), isSelected, isPreview);
        return /*#__PURE__*/_jsx(Td, _objectSpread(_objectSpread({
          px: 2,
          py: 1.5
        }, styleAndProps), {}, {
          e2eid: "CrudTable_TableRow_Td",
          children: flexRender((_columnDef$cell = columnDef.cell) !== null && _columnDef$cell !== void 0 ? _columnDef$cell : cell.renderValue(), cell.getContext())
        }), cell.id);
      })
    })
  });
};